import styled from "styled-components";

export const NavBarElement = styled.nav`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #333;
  color: white;
  padding: 0 20px;
  min-height: 60px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  position: relative;
  flex-wrap: wrap;

  @media (max-width: 1311px) {
    justify-content: center;
    padding: 15px 20px;
    gap: 15px;
  }

  @media (max-width: 768px) {
    justify-content: space-between;
    padding: 10px 20px;
  }
`;

export const NavTitle = styled.h1`
  margin: 0;
  font-size: 1.5rem;

  @media (max-width: 1311px) {
    margin-left: 20px;
  }

  @media (max-width: 768px) {
    font-size: 1.2rem;
    margin-right: 10px;
  }
`;

export const HamburgerMenu = styled.div`
  display: none;
  flex-direction: column;
  cursor: pointer;
  gap: 5px;

  span {
    height: 3px;
    width: 25px;
    background: white;
    border-radius: 5px;
    transition: all 0.3s linear;
  }

  @media (max-width: 768px) {
    display: flex;
  }
`;

export const NavLinks = styled.ul`
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;

  @media (max-width: 1311px) {
    width: 100%;
    justify-content: center;
    flex-wrap: wrap;
  }


  @media (max-width: 768px) {
    flex-direction: column;
    width: 100%;
    position: absolute;
    top: 100%;
    left: 0;
    background-color: #333;
    overflow: hidden;
    max-height: ${({ isOpen }) => (isOpen ? "300px" : "0")};
    transition: max-height 0.3s ease-in-out;
    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.1);
    z-index: 10;
  }
`;

export const NavLink = styled.li`
  margin-left: 20px;
  text-align: center;

  @media (max-width: 1311px) {
    margin: 5px 15px;
  }
  
  @media (max-width: 768px) {
    margin: 0;
    padding: 15px;
    text-align: center;
    border-top: 1px solid #444;
  }

  a {
    color: white;
    text-decoration: none;
    font-size: 1rem;
    transition: color 0.3s;
    
    &:hover {
      color: #ddd;
    }
  }
`;

export const NavImg = styled.img`
    height: 50px;
  
    @media (max-width: 768px) {
      height: 35px;
    }
`
export const NavImageContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 5px;

    @media (max-width: 768px) {
      gap: 2px;
    }
`